import React, { useEffect, useState } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import { useLocation } from "react-router-dom";
import Marquee from "react-fast-marquee";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { Select } from "antd";
import axios from "axios";

import * as Styles from "./Anfrage.styles";
import IphoneImg from "assets/images/iPhone-14.png";
import BottomImg from "assets/images/bottom-lines.png";
import { validationSchema } from "./validationSchema";
import * as CoachActions from "redux/coach/coach.actions";

import Icon1 from "assets/images/anfrage/icon-1.svg";
import Icon2 from "assets/images/anfrage/icon-2.svg";
import Icon3 from "assets/images/anfrage/icon-3.svg";
import Icon4 from "assets/images/anfrage/icon-4.svg";
import Icon5 from "assets/images/anfrage/icon-5.svg";
import { useDispatch, useSelector } from "react-redux";
import { IS_LOCAL } from "configs/utils";
import Loader from "components/General/loader/Loader";

const initialValues = {
  goal: "",
  geschlecht: "",
  vorname: "",
  nachname: "",
  email: "",
  handynummer: "",
  help: "",
};

// Define options for dropdowns
const goalOptions = [
  { value: "Gewichtsabnahme", label: "Gewichtsabnahme" },
  { value: "Muskelaufbau", label: "Muskelaufbau" },
  { value: "Gesunder Lebensstil", label: "Gesunder Lebensstil" },
];

const genderOptions = [
  { value: "Männlich", label: "Männlich" },
  { value: "Weiblich", label: "Weiblich" },
  { value: "Keine Angabe", label: "Keine Angabe" },
];

const Anfrage = () => {
  const { coach } = useSelector((state) => state.coach);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [ipAddress, setIpAddress] = useState("");
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const refParam = params.get("ref");
  useEffect(() => {
    window.scrollTo(0, 0);

    if (coach) return;

    const coach_website_url = IS_LOCAL
      ? "https://ronja-fci49818.foodiary.app"
      : `${window.location.protocol}//${window.location.host}`;

    dispatch(
      CoachActions.trainerIdRequest({
        formData: { coach_website_url },
        callback: (res) => {
          dispatch(
            CoachActions.coachDataRequest({
              formData: { trainerID: res?.trainerID },
              callback: (res) => {
                console.log(res);
              },
            })
          );
        },
      })
    );
  }, [dispatch, coach]);

  useEffect(() => {
    const fetchIpAddress = async () => {
      try {
        const response = await axios.get("https://api.ipify.org?format=json");
        setIpAddress(response.data.ip);
      } catch (error) {
        console.error("Error fetching IP address:", error);
      }
    };

    fetchIpAddress();
  }, []);

  const handleSubmit = (values, { setSubmitting, setErrors, resetForm }) => {
    console.log(values);

    setSubmitting(true);

    // Format the date as d/m/Y
    const today = new Date();
    const formattedDate = `${today.getDate().toString().padStart(2, "0")}/${(
      today.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}/${today.getFullYear()}`;

    const body = {
      connected_trainer: coach?.trainerID,
      prename: values?.vorname,
      surename: values?.nachname,
      mobilenumber: values?.handynummer,
      email: values?.email,
      lead_source: "Coach Webseite",
      lead_received: formattedDate, // Format: "14/07/2024"
      lead_contacted: "",
      lead_status: "received",
      lead_goal: values?.goal,
      lead_gender: values?.geschlecht,
      lead_age: "0", // Set a default value for age
      lead_proposed_date: "",
      lead_informations: values?.help,
    };
    setLoading(true);
    dispatch(
      CoachActions.createLeadsCenter({
        body,
        callback: (res) => {
          setSubmitting(false);
          if (res) {
            if (res instanceof Error) {
              setSubmitting(false);
              setLoading(false);

              const errors = res.response?.data?.error;
              console.log("🚀 ~ handleSubmit ~ errors:", errors);

              if (errors?.email) {
                // Set the email error in Formik directly
                setErrors({ email: errors.email[0] });
                // Optionally scroll to the email field
                // const emailField = document.querySelector(
                //   'input[name="email"]'
                // );
                // if (emailField) {
                //   emailField.scrollIntoView({
                //     behavior: "smooth",
                //     block: "center",
                //   });
                // }
              } else {
                alert("❌ Something went wrong");
              }
            } else {
              console.log("🚀 ~ handleSubmit ~ res:", res);
              createCustomerOnTapifiliate(values, resetForm);
            }
          }
        },
      })
    );
  };

  const createCustomerOnTapifiliate = async (values, resetForm) => {
    const payload = {
      customer_id: values.email,
      referral_code: refParam || coach?.affiliate_code || "ogmwmdy",
      meta_data: {
        Source_vom_Klient: "Anfrageformular Coach Webseite",
        vorname_klient: values.vorname,
        nachname_klient: values.nachname,
        email_klient: values.email,
        FranchiseID: coach?.FranchiseID,
        email_coach: coach?.email,
        fullname_coach: `${coach?.prename} ${coach?.surname}`,
        user_agent: navigator.userAgent,
        ip: ipAddress,
        landing_page: window.localStorage.href,
      },
    };

    try {
      const response = await axios.post(
        "https://api.tapfiliate.com/1.6/customers/",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            "Api-Key": "3acc178a1eff97b14cc1b12c00222e070a3a1b91",
          },
        }
      );
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
      resetForm();
      // empty the whole form
      // setFieldValue("goal", "");

      // Reset the form or show a success message
      alert("✅ Anfrage erfolgreich gesendet!");
    }
  };

  return (
    <>
      <Styles.Container>
        <Styles.SectionContainer>
          <Styles.LeftSection>
            {/* Desktop icon positioning */}
            <img src={Icon1} alt="Icon1" className="icon1" />
            <img src={Icon2} alt="Icon2" className="icon2" />
            <img src={Icon3} alt="Icon3" className="icon3" />
            <img src={Icon4} alt="Icon4" className="icon4" />
            <img src={Icon5} alt="Icon5" className="icon5" />
            {/* Mobile marquee */}
            <div className="mobile-marquee">
              <Marquee speed={120} gradient={false} direction="left">
                <Styles.MarqueeItem>
                  <img src={Icon1} alt="Icon1" />
                </Styles.MarqueeItem>
                <Styles.MarqueeItem>
                  <img src={Icon2} alt="Icon2" />
                </Styles.MarqueeItem>
                <Styles.MarqueeItem>
                  <img src={Icon3} alt="Icon3" />
                </Styles.MarqueeItem>
                <Styles.MarqueeItem>
                  <img src={Icon4} alt="Icon4" />
                </Styles.MarqueeItem>
                <Styles.MarqueeItem>
                  <img src={Icon5} alt="Icon5" />
                </Styles.MarqueeItem>
              </Marquee>
            </div>

            <Styles.Title className="text-3xl">
              Ich bin dein Coach {coach?.prename ?? ""}.
            </Styles.Title>
            <Styles.PhoneImage src={IphoneImg} alt="phoneImage" />
            <Styles.BottomImage src={BottomImg} alt="bottomImage" />
            <Styles.BottomTitle>Powered by Foodiary.</Styles.BottomTitle>
          </Styles.LeftSection>
          <Styles.RightSection>
            <h2>Hey,</h2>
            <p className="text-lg">
              ich bin {coach?.prename ?? ""} {coach?.surname ?? ""}! 👋
              Interessierst du dich für mein Ernährungscoaching? Dann melde dich
              gerne über das untenstehende Formular!
            </p>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting, handleChange, values, setFieldValue }) => (
                <Form>
                  <Styles.FieldRow>
                    <Styles.FieldContainer>
                      <Styles.FieldLabel>Dein Ziel*</Styles.FieldLabel>
                      {/* Replace input with Select dropdown */}
                      <Select
                        options={goalOptions}
                        placeholder="Wähle dein Ziel"
                        style={{ width: "100%" }}
                        onChange={(value) => setFieldValue("goal", value)}
                        value={values.goal || undefined}
                      />
                      <ErrorMessage name="goal" component={Styles.ErrorText} />
                    </Styles.FieldContainer>
                    <Styles.FieldContainer>
                      <Styles.FieldLabel>Geschlecht*</Styles.FieldLabel>
                      {/* Replace input with Select dropdown */}
                      <Select
                        options={genderOptions}
                        placeholder="Wähle dein Geschlecht"
                        style={{ width: "100%" }}
                        onChange={(value) => setFieldValue("geschlecht", value)}
                        value={values.geschlecht || undefined}
                      />
                      <ErrorMessage
                        name="geschlecht"
                        component={Styles.ErrorText}
                      />
                    </Styles.FieldContainer>
                  </Styles.FieldRow>
                  <Styles.FieldRow>
                    <Styles.FieldContainer>
                      <Styles.FieldLabel>Vorname*</Styles.FieldLabel>
                      <Styles.InputField
                        type="text"
                        name="vorname"
                        placeholder="Vorname"
                        onChange={handleChange}
                        value={values.vorname}
                      />
                      <ErrorMessage
                        name="vorname"
                        component={Styles.ErrorText}
                      />
                    </Styles.FieldContainer>
                    <Styles.FieldContainer>
                      <Styles.FieldLabel>Nachname*</Styles.FieldLabel>
                      <Styles.FieldContainer>
                        <Styles.InputField
                          type="text"
                          name="nachname"
                          placeholder="Nachname"
                          onChange={handleChange}
                          value={values.nachname}
                        />
                      </Styles.FieldContainer>
                      <ErrorMessage
                        name="nachname"
                        component={Styles.ErrorText}
                      />
                    </Styles.FieldContainer>
                  </Styles.FieldRow>
                  <Styles.FieldRow>
                    <Styles.FieldContainer>
                      <Styles.FieldLabel>E-Mail*</Styles.FieldLabel>
                      <Styles.InputField
                        type="text"
                        name="email"
                        placeholder="E-Mail"
                        onChange={handleChange}
                        value={values.email}
                      />
                      <ErrorMessage name="email" component={Styles.ErrorText} />
                    </Styles.FieldContainer>
                    <Styles.FieldContainer>
                      <Styles.FieldLabel>Handynummer*</Styles.FieldLabel>
                      <Styles.StyledPhoneInputWrapper>
                        <PhoneInput
                          international
                          defaultCountry="DE"
                          value={values.handynummer}
                          onChange={(phone) =>
                            setFieldValue("handynummer", phone)
                          }
                          placeholder="+49 1741953597"
                        />
                      </Styles.StyledPhoneInputWrapper>
                      <ErrorMessage
                        name="handynummer"
                        component={Styles.ErrorText}
                      />
                    </Styles.FieldContainer>
                  </Styles.FieldRow>
                  <Styles.FieldContainer>
                    <Styles.FieldLabel>
                      Wie kann ich dich unterstützen?*
                    </Styles.FieldLabel>
                    <Styles.TextAreaField
                      type="text"
                      name="help"
                      placeholder="Schreibe mir eine kurze Nachricht…"
                      onChange={handleChange}
                      value={values.help}
                    />
                  </Styles.FieldContainer>
                  <ErrorMessage name="help" component={Styles.ErrorText} />
                  {loading ? (
                    <Loader />
                  ) : (
                    <Styles.ButtonWrapper
                      type="submit"
                      className="btn-dark w-100 m-auto "
                      disabled={isSubmitting}
                    >
                      {isSubmitting
                        ? "Ich bin interessiert..."
                        : "Ich bin interessiert"}
                    </Styles.ButtonWrapper>
                  )}
                </Form>
              )}
            </Formik>
          </Styles.RightSection>
        </Styles.SectionContainer>
      </Styles.Container>
    </>
  );
};
export default Anfrage;
